import styled from 'styled-components'
import { rem } from 'polished'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import type { RecentCarHireSearch as RecentCarHireSearchType } from '../carHireRecentSearches'
import RecentCarHireSearch from '../RecentCarHireSearch/RecentCarHireSearch'

const RecentSearchesWrapper = styled.div`
  margin-top: ${rem(16)};
`

interface Props {
  recentSearches: Array<RecentCarHireSearchType>
}

function RecentCarHireSearches({ recentSearches }: Props) {
  return (
    <RecentSearchesWrapper>
      <CSSBreakpoint min="tablet">
        <CardCarousel
          snap="center"
          pageSize={3}
          gap={20}
        >
          {recentSearches.map(search => (
            <RecentCarHireSearch key={search.id} recentSearch={search} />
          ))}
        </CardCarousel>
      </CSSBreakpoint>
      <CSSBreakpoint max="mobile">
        <Group direction="vertical" gap={8}>
          {recentSearches.map(search => (
            <RecentCarHireSearch key={search.id} recentSearch={search} />
          ))}
        </Group>
      </CSSBreakpoint>
    </RecentSearchesWrapper>
  )
}

export default RecentCarHireSearches
